import script from "./GGanttRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttRow.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttRow.vue?vue&type=style&index=0&id=33aadb70&lang=css"

const __exports__ = script;

export default __exports__